/**
 * Asset Manager
 * Dynamic script loading for conditional elements
 * @type {Object}
 */
var AssetManager = {
    assets : {},

    loadAsset : function(asset, script, callback){
        var A = this,
            _script = document.createElement('script'),
            id = 'asset-' + script.id,
            callback = callback || function(){};

        _script.isLoaded = false;

        var scriptOnload = function(){
            asset.loaded++;
            _script.isLoaded = true;

            if ( asset.loaded == asset.scripts.length ){
                A.triggerCallbacks(asset.callbacks);
            }

            callback.call(undefined, asset, script);
        };

        // make sure we haven't added the asset already
        if ( document.getElementById(id) ) {
            var checkIfLoaded = function(){
                if ( document.getElementById(id).isLoaded ) {
                    // if we have, just run the callbacks
                    A.triggerCallbacks(asset.callbacks);
                } else {
                    setTimeout(checkIfLoaded, 50);
                }
            };
            
            setTimeout(checkIfLoaded, 50);
        } else {
            // if not, build it out and append it to the DOM
            _script.id = id;
            _script.src = script.path;

            // setup callback function
            _script.onload = scriptOnload;

            // for old IE
            _script.onreadystatechange = function(){
                if ( this.readyState === 'complete' || this.readyState === 'loaded' ){
                    scriptOnload();
                }
            };

            document.body.appendChild(_script);
        }
    },

    triggerCallbacks : function(callbacks){
        for ( var i = 0; i < callbacks.length; i++ ){
            if ( typeof callbacks[i] == 'function' ) callbacks[i].call(undefined);
        }
    },

    load : function(assets){
        var A = this,
            assets = assets || {};

        for ( var i in assets ) {
            var asset = assets[i];

            if ( typeof asset.scripts !== 'undefined' ){
                var scriptsLength = asset.scripts.length;

                if ( scriptsLength > 0 ){
                    var scripts = [],
                        scriptsToLoad = [];
                    var s, index;

                    asset.loaded = 0;

                    // check for duplicates and prepare script array
                    for ( var x = 0; x < asset.scripts.length; x++ ){
                        if (scripts.indexOf(asset.scripts[x].id) > -1 ) {
                            asset.scripts.splice(x, 1);
                        } else {
                            scripts.push(asset.scripts[x].id);
                            scriptsToLoad.push(asset.scripts[x]);
                        }
                    }

                    // reset asset scripts with just the ones we need to load
                    asset.scripts = scriptsToLoad;

                    for ( var s = 0; s < asset.scripts.length; s++ ){
                        // load our asset script
                        A.loadAsset(asset, asset.scripts[s]);
                    }
                } else if ( asset.callbacks.length > 0 ) {
                    A.triggerCallbacks(asset.callbacks); 
                }
            }
        }
    },

    init : function(){
        this.load(this.assets);
    }
};